import { RouteConfig } from 'vue-router';

import ProfileOffers from '@/views/profile/Offers.vue';

export function profileOffersRoute(name: string): RouteConfig {
  return {
    path: 'offers',
    name,
    component: ProfileOffers,
    meta: {
      authorized: true
    }
  };
}
